import { render, staticRenderFns } from "./ScreenStudent.vue?vue&type=template&id=7202dece&scoped=true"
import script from "./ScreenStudent.vue?vue&type=script&lang=js"
export * from "./ScreenStudent.vue?vue&type=script&lang=js"
import style0 from "./ScreenStudent.vue?vue&type=style&index=0&id=7202dece&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202dece",
  null
  
)

export default component.exports